export class BuilderTabsService {
    static $inject = ['SidebarContentService'];
    constructor(SidebarContentService) {
        this.SidebarContentService = SidebarContentService;
        this.openedSubSidebars = [];
    }
    addSidebar(sidebar) {
        this.openedSubSidebars = this.openedSubSidebars.concat(sidebar);
    }
    closeOpenedSidebars() {
        this.openedSubSidebars.forEach(s => {
            this.SidebarContentService.cleanAndClose(undefined, s);
        });
        this.openedSubSidebars = [];
    }
    validateTab(elementReferenceId, state) {
        const customActionsTabElement = document.getElementById(elementReferenceId);
        if (customActionsTabElement) {
            if (state.$invalidCustomActions) {
                customActionsTabElement.classList.add('invalid-background');
            }
            else {
                customActionsTabElement.classList.remove('invalid-background');
            }
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
BuilderTabsService.$inject = ['SidebarContentService'];
